import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import NavBrand from "./nav/NavBrand";
import DesktopNav from "./nav/DesktopNav";
import MobileNav from "./nav/MobileNav";

const Navbar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = useCallback(() => setScrolled(window.scrollY > 40), []);

  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // Transparent over hero only on home page before scroll
  const transparent = location.pathname === "/" && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        transparent
          ? "bg-transparent py-5"
          : "bg-[#f6f2ed]/95 backdrop-blur-md py-3 shadow-[0_1px_20px_-8px_rgba(58,55,54,0.25)]"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 flex items-center justify-between">
        <NavBrand transparent={transparent} />
        <DesktopNav pathname={location.pathname} transparent={transparent} />
        <MobileNav pathname={location.pathname} transparent={transparent} />
      </div>
    </header>
  );
};

export default Navbar;
